import React from "react"
import { MarkdownOutput } from "../Markdown/MarkdownOutput"

const KnowledgeArticleContentText = ({ value }) => <MarkdownOutput>{value}</MarkdownOutput>

export { KnowledgeArticleContentText }
